<div id="emr-ac-login">
  <div class="login-section">
    <div class="logo-section">
      <img src="assets/images/omniaLogo.png">
    </div>
    <div class="login-form">      
      <h5>Sign in with your Username and Password</h5>
      <custom-popup-message></custom-popup-message>
      <div fxLayout="column">
        <mat-form-field>
          <input id="emailID" matInput type="email" [(ngModel)]="Username" placeholder="Username" (keyup.enter)="onSubmitLogin()" />
        </mat-form-field>
        <mat-form-field>
          <input id="passwordID" matInput [type]="!showPassword ? 'password' : 'text'" [(ngModel)]="Password" placeholder="Password"
            (keyup.enter)="onSubmitLogin()" />
          <mat-icon id="showPasswordID" matSuffix class="cursor" (click)="showPassword = !showPassword">
            {{!showPassword ? 'visibility_off' : 'visibility'}}
          </mat-icon>
        </mat-form-field>
        <div id="forgotPassword" class="forgotPswLink" (click)="forgotPassword()">
          Forgot your password ?
        </div>
      </div>
      <div fxLayout="column" style="align-items: center;">
        <button style="width: 150px;" mat-raised-button color="primary" (click)="onSubmitLogin()">Sign In</button>
      </div>
    </div>
  </div>
</div>